/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import Link from "./link";

const LinkFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};
    
    return (
        <FieldDisplayWrapper>
            {values &&
                values.map((valueItem, index) => {
                    const value = valueItem?.value;
                    // const settings = valueItem?.settings;
                    return (
                        <div
                            className='fields-link-item'
                            key={index}
                        >
                            <Link link={value} />
                        </div>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
LinkFieldDisplay.displayName = "LinkFieldDisplay";
export { LinkFieldDisplay };
